import * as React from 'react';
// TODO: Remove when use `responsiveImmutable`
var PerfContext = /*#__PURE__*/React.createContext({
  renderWithProps: false
});
export default PerfContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/context/PerfContext.js
// module id = 916
// module chunks = 0